//=================================================
//    summary: DCP Email驗證成功視窗 EmailVerifiedSuccess -- Hook
//
//    remarks: 000 Tim 2021/12/21 Create
//================================================
import React, { useEffect } from 'react'
import cssEmailVerifiedSuccess from './EmailVerifiedSuccess.module.scss'
import {GlobalLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false
// #endregion Member Variables


const COMP_NAME = "EmailVerifiedSuccess"

function EmailVerifiedSuccess(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 立即驗證
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function OKOnTapHandler()
    {
        console.log(COMP_NAME + ".OKOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objCallbackData = {
            "Action": "CloseShowEmailVerifiedSuccess"
        }
        props.CallbackRef(objCallbackData)
    } // end of OKOnTapHandler
    // #endregion OnTapHandler

    // #region Render
    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssEmailVerifiedSuccess.divContent}>
                <div className={cssEmailVerifiedSuccess.divMessage}>
                    {window.gAppUI.MSG_VerifiedSuccessfully}
                </div>
                
                <div className={cssEmailVerifiedSuccess.btnOK} onClick={() => OKOnTapHandler()}>
                    {PackageVariablesLibs.UISettings.BTN_OK}
                </div>
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssEmailVerifiedSuccess.divMask}>
                <div className={cssEmailVerifiedSuccess.divMain}>
                    {RenderContentWrapper()}
                </div>
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default EmailVerifiedSuccess